import { AxiosResponse } from "axios"
import { call, put, select, takeLeading } from "redux-saga/effects"
import { AppService } from "src/services/app"
import { getBaseUrl } from "../selectors/features/app"
import { bulkSendFailure, bulkSendSuccess } from "../slices/features/bulkSend"
import { RequestTypes } from "../types"

const appservice = new AppService()

function* postBulkSendAsyncSaga(action: any) {
  const { payload } = action
  const { id, data } = payload
  try {
    const baseUrl: string = yield select(getBaseUrl)
    const response: AxiosResponse<any> = yield call(appservice.postBulkSendAsync, baseUrl, id, data)
    yield put(bulkSendSuccess())
    payload?.cbSuccess && payload?.cbSuccess({ ...response })
  } catch (error: any) {
    const message = error?.statusText || error?.data?.errors?.message
    payload?.cbFailure && payload?.cbFailure(message)
    yield put(bulkSendFailure({ statusCode: error?.statusCode, statusText: error?.statusText }))
  }
}

export function* watchPostBulkSendAsync() {
  yield takeLeading(RequestTypes.POST_BULK_SEND_ASYNC, postBulkSendAsyncSaga)
}
